module.exports = __webpack_public_path__ + "img/02-9.e0cfd880.png";